import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {UsuarioProvider} from './Provedores/UsuarioContext'
import { ThemeProvider, createTheme } from '@material-ui/core/styles';

const theme = createTheme();

ReactDOM.render(
  <React.StrictMode>
    <UsuarioProvider>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>

    </UsuarioProvider>
    
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
